import Vue from 'vue'

Vue.filter('StatusFile', function (status) {
  return status === 'transpickup' ? 'En proceso de recojo' : status === 'pickup' ? 'Solicitud recojo' : status === 'imported' ? 'Importado' : status === 'stock' ? 'En stock' : status === 'req' ? 'Solicitado' : status === 'trans' ? 'En transporte' : status === 'out' ? 'En cliente' : 'Eliminado'
})

Vue.filter('StatusOrder', function (status) {
  if (status === 'pen') return 'Pendiente'
  if (status === 'apr') return 'Aprobado'
  if (status === 'env') return 'Enviado'
  if (status === 'envobs') return 'Enviado con observaciones'
  if (status === 'ent') return 'Entregado'
  if (status === 'entobs') return 'Entregado  con observaciones'
  if (status === 'recog') return 'Recogido'
  if (status === 'can') return 'Cancelado'
  if (status === 'recep') return 'Recepcionado'
  if (status === "trans") return 'En tránsito'
  return 'Desconocido'
})

Vue.filter('Capitalize', function (value) {
  if (!value) return ''
  value = value.toString().toLowerCase()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('StatusImport', function (value) {
  if (!value) return ''
  if (value === 'upinit') return 'Sin procesar'
  if (value === 'proc') return 'Procesado'
  if (value === 'procerr') return 'Procesado con error'
  if (value === 'noread') return 'No leible'
  if (value === 'revert') return 'Revertido'
  if (value === 'cancel') return 'Cancelado'
  if (value === 'finish') return 'Finalizado'
})

Vue.filter('StatusDigitalization', function (status) {
  if (status === 'req') return 'Pendiente'
  if (status === 'comp') return 'Aprobado'
  if (status === 'canc') return 'Cancelado'
  if (status === 'dis') return 'Desaprobado'
  if (status === 'del') return 'Entregado'
  return 'Error'
})

Vue.filter('StatusconsulFiles', function (status) {
  if (status === 'req' || status === 'low_box' || status === 'low_file') return 'Pendiente'
  if (status === 'comp' || status === 'final_departure') return 'Aprobado'
  if (status === 'canc') return 'Cancelado'
  if (status === 'dis') return 'Desaprobado'
  if (status === 'fina') return 'Finalizado'
  if (status === 'apr') return 'Aprobado'
  return 'Error'
})

Vue.filter('NamePriority', function (priority) {
  if (priority === 'normal') return 'Normal'
  if (priority === 'urgent') return 'Urgente'
  if (priority === 'Prioridad Crítico') return 'Crítico'
  return priority
})

Vue.filter('TypeImport', function (type) {
  if (type === 'FILE') return 'Files'
  if (type === 'MICROFORMA') return 'Microformas'
  if (type === 'MEDIOS') return 'Medios'
  if (type === 'PLANOS') return 'Planos'
  if (type === 'MUESTRAS') return 'Muestras'
  if (type === 'BOX') return 'Cajas'
  if (type === 'BOX_MEDIOS') return 'Caja Medios'
  if (type === 'BOX_LOCKER') return 'Casillero'
  if (type === 'BOX_PLANOS') return 'Caja Planos'
  if (type === 'BOX_MUESTRAS') return 'Caja Muestras'
  return 'Sin tipo'
})

Vue.filter("FileSize", function (tam) {
  var units = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB'
  ];

  if (isNaN(parseFloat(tam)) || !isFinite(tam)) {
    return '?';
  }

  var unit = 0;

  while (tam >= 1024) {
    tam /= 1024;
    unit++;
  }
  return parseFloat(tam).toFixed(2) + ' ' + units[unit];
})

Vue.filter('numberFormat', function (total) {
  const formatter = new Intl.NumberFormat('es-PE', {
    style: 'currency',
    currency: 'PEN',
    minimumFractionDigits: 2
  })
  return formatter.format(total);
})



// WEBPACK FOOTER //
// ./src/filters/index.js